// ---------------------------------------------------------------------------
// The colour dot beside a segment (AL-1850)
// ---------------------------------------------------------------------------
// CT-0 draws each recent segment with a coloured dot. A persona carries no
// colour — there is no such column — so the dot is derived from its id, which
// keeps it stable for a given segment across reloads and across viewers
// without pretending the backend stores a choice it does not.
//
// The palette is the chart series from AL-1849, so the dots stay inside the
// token system in both themes.
// ---------------------------------------------------------------------------

const DOT_CLASSES: readonly string[] = [
  'bg-v11-chart-series-a',
  'bg-v11-chart-negative',
  'bg-v11-chart-series-b',
  'bg-v11-chart-warning',
  'bg-v11-chart-positive',
];

export function segmentDotClass(personaId: number): string {
  const index = Math.abs(Math.trunc(personaId)) % DOT_CLASSES.length;
  return DOT_CLASSES[index];
}

export const SEGMENT_DOT_CLASSES = DOT_CLASSES;
